module.exports = __webpack_public_path__ + "static/img/banner.08f1c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/banner.png
// module id = Amwu
// module chunks = 44